import { render, staticRenderFns } from "./PayForm.vue?vue&type=template&id=cc54b6dc&scoped=true&"
import script from "./PayForm.vue?vue&type=script&lang=js&"
export * from "./PayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc54b6dc",
  null
  
)

export default component.exports